import axios from "axios";
import {
  ADD_CARD,
  GET_CARDS,
  SET_DEFAULT_CARD,
  CREATE_CARD_TOKEN,
  REMOVE_CARD,
  GET_PLANS,
  GET_ACTIVE_SUBCRIPTION_PLAN,
  RETRIVE_EVENTS,
  GET_INVOICES,
  GET_TRANSACTIONS,
  CAPTURE_WEB_HOOKS,
  CHECK_PAYMENT_SOURCES_EXISTENCE,
  interceptor
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function addCard(data) {
  return {
    type: ADD_CARD,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/payment/addCard`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteCard() {}
  export function getCards() {
  const user = store.getState().userReducer.currentUser;
  return {
    type: GET_CARDS,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/payment/getCards`,
      { user },
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function setDefault(pet) {
  return {
    type: SET_DEFAULT_CARD,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/default/${pet.id}`, pet, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function clear() {
  return {
    type: 'CLEAR_ANIMAL_TYPE',
    payload: null
  };
}

export function getEditable(edited) {
  return {
    type: 'UPDATE_ANIMAL',
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/${edited.id}`, edited, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function getDeletable(selected) {
  const ids = { ids: selected };
  return {
    type: 'DELETE_ANIMAL',
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
